module.exports = __webpack_public_path__ + "static/img/minip2.b06a78e8.png";